import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Container, Image, Text } from "@atoms";
import { HeadingWIcon } from "@molecules";

const Hero = ({
  backgroundImage,
  heading,
  subheading,
  copy,
  featuredAction,
  cards,
  sidebar,
}) => {
  const { romero, lgca, lakota } = brand;
  return (
    <div
      className={classNames("relative z-0 bg-black pb-12 pt-48 lg:pb-20", {
        "bg-blue": lgca || romero,
        "bg-brown": lakota,
      })}
    >
      <div className="absolute inset-0 z-0">
        {backgroundImage && (
          <Image ixParams={{ bri: "-25" }} fill image={backgroundImage} />
        )}
        {backgroundImage && (
          <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/90 via-black/50 to-black/90" />
        )}
      </div>
      <div className="relative z-10">
        <Container>
          <div className="flex items-center">
            <div
              className={classNames("relative z-10 w-full md:w-3/5", {
                "mx-auto": !sidebar,
              })}
            >
              <HeadingWIcon
                icon="sunrise"
                inverse
                heading={heading}
                copy={copy}
              />
              {subheading && subheading.length > 1 && (
                <Text
                  variant="h4"
                  className={classNames("mt-6", {
                    "text-red": !romero,
                    "text-black": romero && !backgroundImage,
                    "text-white": backgroundImage && romero,
                  })}
                >
                  {subheading}
                </Text>
              )}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

Hero.defaultProps = {};

export default Hero;
